import { useElementSize } from "@vueuse/core"
import { computed, watch } from "vue"

/**
 * 返回表格是否超出父元素
 * @param {*} refTableParent 父元素
 * @param {*} refTable 表格元素
 * @returns 
 */
const useTableSticked = (refTableParent, refTable) => {
  const { width: tableParentWidth } = useElementSize(refTableParent)
  const { width: tableWidth } = useElementSize(refTable)
  const tableIsSticked = computed(() => {
    return tableWidth.value > tableParentWidth.value
  })
  watch(() => tableIsSticked.value, (val) => {
    if (refTable.value) {
      if (val) {
        refTable.value.classList.add('sticked')
      } else {
        refTable.value.classList.remove('sticked')
      }
    }
  }, { immediate: true })
  return tableIsSticked
}

export default useTableSticked